import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import OnBoarding from "@/assets/images/OnBoarding.png";
import OnBoarding2 from "@/assets/images/OnBroading-2.png";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type OnboardingModalProps = {
  responsive: any;
  openOnboarding: boolean;
  setOpenOnboarding: (open: boolean) => void;
  setOpenModal: (open: boolean) => void;
};

const OnboardingModal: React.FC<OnboardingModalProps> = ({
  responsive,
  openOnboarding,
  setOpenOnboarding,
  setOpenModal,
}) => {
  return (
    <Dialog
      open={openOnboarding}
      onOpenChange={setOpenOnboarding}
    >
      <DialogContent className="sm:max-w-[520px] bg-white p-6 gap-0 rounded-lg border border-gray-200 shadow-lg">
        <DialogHeader className="px-6 pt-6 pb-4 text-center">
          <DialogTitle className="text-lg font-semibold text-gray-900 text-center">
            Tạo nhóm trong tổ chức
          </DialogTitle>
        </DialogHeader>

        <Carousel
          responsive={responsive}
          autoPlay
          autoPlaySpeed={4000}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={1000}
          arrows={false}
          showDots={true}
          shouldResetAutoplay
          infinite={true}
        >
          <div className="text-center space-y-6 pb-10">
            <img
              src={OnBoarding}
              alt="Cơ cấu tổ chức"
              className="w-20 h-20 mx-auto object-contain"
            />
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-gray-900">
                Cơ cấu tổ chức phân tầng
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Tạo nhiều nhóm con với phân tầng rõ ràng để tái hiện cơ cấu tổ
                chức thực tế. Quản lý chính sách, phân quyền và mối quan hệ giữa
                các bộ phận một cách hiệu quả.
              </p>
              <p className="text-sm text-gray-600">
                Bạn có quyền kiểm duyệt và tuỳ chỉnh nhóm bất cứ lúc nào.
              </p>
            </div>
          </div>

          <div className="text-center space-y-6">
            <img
              src={OnBoarding2}
              alt="Làm việc nhóm"
              className="w-20 h-20 mx-auto object-contain"
            />
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-gray-900">
                Làm việc nhóm hiệu quả
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Mỗi nhóm là không gian độc lập với đầy đủ tính năng quản lý công
                việc. Triển khai đúng quyền hạn và quy trình của tổ chức.
              </p>
              <p className="text-sm text-gray-600">
                Xây dựng và quản lý cơ cấu bộ phận theo ý muốn.
              </p>
            </div>
          </div>
        </Carousel>

        <div className="flex justify-center pt-4">
          <Button
            variant="primary"
            onClick={() => {
              setOpenModal(true);
              setOpenOnboarding(false);
            }}
            className="h-10 px-6 bg-blue-600 hover:bg-blue-700 text-white"
          >
            Bắt đầu tạo
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingModal;
